import { useMutation, useQuery } from "@tanstack/react-query";
import queryKey from "../../enumerations/queryKey";
import { removePromoteCode } from "../../plugins/checkoutFunction";
import {
  apiCheckDiscount,
  apiCheckPromote,
  apiGetGiftPointRatio,
  apiGetProductItems,
  apiPostCheckoutCart,
} from "./service";

export const useGetProductItem = (params: any, options: any) => {
  return useQuery<any>({
    queryKey: [queryKey.PRODUCT_ITEM, params],
    queryFn: () => apiGetProductItems(params).then((res: any) => res.data.data),
    ...options,
  });
};
export const GetProductItems = () => {
  return useMutation({
    mutationFn: ({ params }: { params: any }) => apiGetProductItems(params),
  });
};

export const useCheckDiscount = (params: any, options: any) => {
  return useQuery<any>({
    queryKey: [queryKey.DISCOUNT, params],
    queryFn: () => apiCheckDiscount(params).then((res: any) => res.data.data),
    ...options,
  });
};

export const useCheckPromote = (params: any, options: any) => {
  return useQuery<any>({
    queryKey: [queryKey.PROMOTE, params],
    queryFn: () => apiCheckPromote(params).then((res: any) => res.data.data),
    ...options,
  });
};

export const useCheckout = () => {
  return useMutation({
    mutationFn: ({ params }: { params: any }) => apiPostCheckoutCart(params),
    onSuccess: () => {
      removePromoteCode();
    },
  });
};

export const useGetGiftPointRatio = (params: any) => {
  return useQuery<any>({
    queryKey: [queryKey.GIFT_POINT_RATIO, params],
    queryFn: () =>
      apiGetGiftPointRatio(params).then((res: any) => res.data.data),
  });
};
